import { RichText } from '../../molecules/RichText'

import type { Document } from '@contentful/rich-text-types'

export interface TextComponentProps {
  title: Document
  description: Document
}

export const TextComponent = (props: TextComponentProps) => {
  return (
    <div className="text-align--center">
      <RichText content={props.title} />
      <RichText content={props.description} />
    </div>
  )
}

export default TextComponent
